import { createRoute } from "@tanstack/react-router";

import SavedSearches from "components/saved_searches/SavedSearches";
import { rootRoute } from "../rootRoute";

export const savedSearchesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/search/saved",
  staticData: { pageName: "Saved Searches" },
  component: SavedSearches,
});
